/**
 * L2-P4: moved to @miq/shared-models (constants/storage.constants.ts). Shim for compat.
 */
export { SEARCH_STATE_KEY, ENTITY_SUBTAB_SORT_KEY } from '@miq/shared-models';
